if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"oc_ui","remotes":[{"alias":"sd_pdp_ui","name":"sd_pdp_ui","entry":"/searchdiscover/pdp-ui/static/app/sd_pdp_ui.js","shareScope":"default"},{"alias":"sd_articlesearch_ui","name":"sd_articlesearch_ui","entry":"/searchdiscover/articlesearch-ui/static/app/sd_articlesearch_ui.js","shareScope":"default"},{"alias":"uidispatcher_api","name":"uidispatcher_api","entry":"/ordercapture/uidispatcher/static/uidispatcherapi.js","shareScope":"default"}],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(182|3214|3785|4638|4854|5501|7327|8815)$/.test(chunkId)},
		rootOutputDir: "../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}